/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * IntakeApp
 * OpenAPI spec version: v1
 */

export type AlertSeverity = typeof AlertSeverity[keyof typeof AlertSeverity];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AlertSeverity = {
  Error: 'Error',
  Warning: 'Warning',
  Info: 'Info',
  Neutral: 'Neutral',
} as const;
